/**
 * 车辆选项加载 Hook
 *
 * 层级：hooks（"React 生命周期"）
 *
 * 职责：
 * 1. 在表单需要车辆选择时懒加载车辆列表
 * 2. 复用 searchStore.vehicleOptionList，避免顶部车号搜索和右侧表单各维护一份数据
 *
 * 不关心地图 SDK 与表单提交，只负责下拉选项数据准备。
 */
import { useCallback, useEffect } from 'react';
import { HttpStatusCode } from '@/fetch/core/constant';
import { useSearchStore } from '../store/searchStore';
import { mapEditorFetch } from '../utils/fetch';

export const useVehicleOptions = (enabled: boolean) => {
  const vehicleOptionList = useSearchStore((s) => s.vehicleOptionList);
  const setVehicleOptionList = useSearchStore((s) => s.setVehicleOptionList);

  const loadVehicleOptions = useCallback(async () => {
    if (!enabled || vehicleOptionList.length > 0) return;

    const res = await mapEditorFetch.fetchVehicleList();
    if (res.code !== HttpStatusCode.Success) return;

    const options = Array.isArray(res.data)
      ? res.data.map((item: any) => ({
        value: item.name,
        label: item.name,
      }))
      : [];
    setVehicleOptionList(options);
  }, [enabled, setVehicleOptionList, vehicleOptionList.length]);

  useEffect(() => {
    loadVehicleOptions();
  }, [loadVehicleOptions]);

  return vehicleOptionList;
};
